// Append-only event log. Every module that mutates sim state records what happened here; reports, the
// sync matrix, advisor prompts, and the debrief all derive from this log rather than from raw state.
import type { Event, EventKind, Side } from './types';

export class EventLog {
  events: Event[] = [];
  private nextId = 1;

  /** Records a new event with an auto-incrementing id and returns it. */
  push(
    t: number,
    kind: EventKind,
    side: Side,
    payload: Record<string, unknown>,
    opts?: { unitId?: number; cell?: number; significant?: boolean },
  ): Event {
    const ev: Event = { id: this.nextId++, t, kind, side, payload, significant: opts?.significant ?? false };
    if (opts?.unitId !== undefined) ev.unitId = opts.unitId;
    if (opts?.cell !== undefined) ev.cell = opts.cell;
    this.events.push(ev);
    return ev;
  }

  /** All events with id strictly greater than the given id, in log order. */
  since(id: number): Event[] {
    return this.events.filter((e) => e.id > id);
  }
}
